import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import CookiesNotSupported from 'views/cookies_not_supported/view'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import cookiesActions from 'redux/actions/cookiesActions'

class CookiesNotSupportedContainer extends PureComponent {

	render() {
		return (
			<CookiesNotSupported
				retry={this.props.actions.retry}
				learnMore={this.props.actions.learnMore}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		retry: cookiesActions.retry,
		learnMore: cookiesActions.goToLearnMore,
	}, dispatch)
}

CookiesNotSupportedContainer.propTypes = {
	actions: PropTypes.shape({
		retry: PropTypes.func.isRequired,
		learnMore: PropTypes.func.isRequired,
	}).isRequired,
}

export default connect(null, mapDispatchToProps)(CookiesNotSupportedContainer)

export {CookiesNotSupportedContainer}
